<template>
  <button
    class="flex-c w-full focus:outline-none"
    @click="goToFirstHighlight"
  >
    <Transition name="fade">
      <!-- <div
        v-show="slug === 'welcome'"
        class="absolute inset-0 bg-white"
      /> -->
    </Transition>

    <div class="relative flex flex-col justify-center h-16 pb-1 font-bold">
      <span class="mx-auto text-sm md:text-base">
        <span>{{ text }}</span>
        <!-- <span v-show="slug !== 'welcome' && slug !== 'more-info'">Keep scrolling for more</span> -->
        <svg xmlns="http://www.w3.org/2000/svg" width="39" height="32" viewBox="0 0 39 32" v-if="icon" v-bind:svg-inline="''" v-bind:class="'inline h-5 w-5 ml-2 mb-px fill-current'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M38.935 6.309H15.24a.463.463 0 01-.462-.461V4.002a.463.463 0 01.461-.462h23.695a.463.463 0 01.462.461v1.846a.463.463 0 01-.461.462zm.461 11.846v-1.846a.463.463 0 00-.461-.462H15.24a.463.463 0 00-.462.461v1.846a.463.463 0 00.461.462h23.695a.463.463 0 00.458-.461zm0 12.307v-1.846a.463.463 0 00-.461-.462H15.24a.463.463 0 00-.462.461v1.85a.463.463 0 00.461.462h23.695a.463.463 0 00.458-.461zm-34.126-4h-.028a2.766 2.766 0 102.766 2.767 2.765 2.765 0 00-2.736-2.765h-.001zM13.156.84l-.569-.569a.92.92 0 00-1.308 0L5.217 6.362 2.263 3.408a.92.92 0 00-1.308 0l-.691.691a.92.92 0 000 1.308L4.44 9.583a.92.92 0 001.308 0l.016-.016 7.377-7.407a.924.924 0 00.015-1.323zm.031 12.307l-.569-.569a.92.92 0 00-1.308 0l-6.062 6.091-2.958-2.954a.92.92 0 00-1.308 0l-.669.691a.92.92 0 000 1.308l4.176 4.176a.92.92 0 001.308 0l-.016-.016 7.407-7.407a.938.938 0 000-1.316z"/></svg>
      </span>
      <span class="chevron-bounce">
        <svg xmlns="http://www.w3.org/2000/svg" width="59" height="32" viewBox="0 0 59 32" v-show="slug !== 'more-info'" v-bind:svg-inline="''" v-bind:class="'h-3 w-6 mt-1 mx-auto fill-current'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M58.471 1.402l-.937-.937a1.583 1.583 0 00-2.244 0L29.477 26.289 3.653.465a1.583 1.583 0 00-2.244 0l-.937.937a1.583 1.583 0 000 2.244l27.876 27.876a1.583 1.583 0 002.244 0L58.468 3.646a1.573 1.573 0 00.003-2.245z"/></svg>
      </span>
    </div>
  </button>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'Footer',

  props: {
    text: {
      type: String,
      default: 'Or keep scrolling to discover the highlights'
    },
    icon: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapState([ 'slug' ]),
    ...mapGetters([ 'highlights', 'scrollActiveLinks' ])
  },

  methods: {
    goToFirstHighlight() {
      const highlightSlugs = this.scrollActiveLinks.map(item => item.slug)
      const currentHighlightIndex = highlightSlugs.findIndex(item => item === this.slug)
      const targetHighlight = highlightSlugs[currentHighlightIndex + 1]

      document.getElementById(`menu-item-${targetHighlight}`).click()
    }
  }
}
</script>

<style scoped>
.chevron-bounce {
  animation: bounce 0.7s infinite ease-in-out alternate;
}

@keyframes bounce {
  100% { transform: translate3d(0, 5px, 0); }
}
</style>
